var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3724_5329)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3724_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6.86777C5 6.41732 5.15766 6.04569 5.47297 5.75291C5.78828 5.46011 6.1982 5.31372 6.7027 5.31372C7.1982 5.31372 7.59909 5.45786 7.90541 5.74615C8.22072 6.04345 8.37838 6.43083 8.37838 6.90832C8.37838 7.34075 8.22523 7.7011 7.91892 7.9894C7.60361 8.28669 7.18919 8.43534 6.67568 8.43534H6.66216C6.16666 8.43534 5.76577 8.28669 5.45946 7.9894C5.15315 7.6921 5 7.31822 5 6.86777ZM5.17568 18.6921V9.66507H8.17568V18.6921H5.17568ZM9.83784 18.6921H12.8378V13.6516C12.8378 13.3362 12.8739 13.093 12.9459 12.9218C13.0721 12.6155 13.2635 12.3565 13.5203 12.1448C13.777 11.9331 14.0991 11.8272 14.4865 11.8272C15.4955 11.8272 16 12.5074 16 13.8678V18.6921H19V13.5164C19 12.1831 18.6847 11.1718 18.0541 10.4826C17.4234 9.79345 16.5901 9.44886 15.5541 9.44886C14.3919 9.44886 13.4865 9.94886 12.8378 10.9489V10.9759H12.8243L12.8378 10.9489V9.66507H9.83784C9.85585 9.95336 9.86486 10.8497 9.86486 12.3543C9.86486 13.8588 9.85585 15.9714 9.83784 18.6921Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3724_5329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3724_5329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.cd364fe6cd716c107f1c1230da7728ce.svg";
export { ForwardRef as ReactComponent };